import { useQuery } from '@tanstack/react-query';

import { api } from 'utils/axios';
import useUrlParams from 'utils/urlParms';

const GET_LEADS_QUERY = 'get-leads';
const GET_LEAD_TRANSITIONS_QUERY = 'get-lead-transitions';

const getLeads = async (params) => {
  try {
    const response = await api.get(`/lead`, { params });
    return response.data;
  } catch (e) {
    console.error(e, 'Error fetching leads');
  }
};

const getLeadTransitions = async (leadId) => {
  try {
    const response = await api.get(`/lead/${leadId}/transitions`);
    return response.data;
  } catch (e) {
    console.error(e, 'Error fetching lead transitions');
  }
}

const useGetLeads = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_LEADS_QUERY, params],

    queryFn: () => getLeads(params),
  });
};

const useGetLeadTransitions = (leadId) => {
  return useQuery({
    queryKey: [GET_LEAD_TRANSITIONS_QUERY, leadId],
    queryFn: () => getLeadTransitions(leadId),
  });
}

export { useGetLeads, GET_LEADS_QUERY, useGetLeadTransitions, GET_LEAD_TRANSITIONS_QUERY };
